import React, { useState } from 'react'

import { Icon, Card } from 'antd'
import { withRouter } from 'react-router-dom'
import styled from 'styled-components'

import colors from '../../../../../components/hocs/colors'
import { MY_ACCOUNT_ROUTES } from '../../../../../utils/routing/routes'

const menuOptions = [
  {
    icon: 'user',
    route: MY_ACCOUNT_ROUTES.BASIC_INFO,
    title: 'Basic Info',
  },
  {
    icon: 'lock',
    route: MY_ACCOUNT_ROUTES.CHANGE_PASSWORD,
    title: 'Change Password',
  },
]

const Container = styled(/** @type {any} */ (Card))``

const Nav = styled.nav`
  display: flex;
  flex-direction: column;
  gap: 4px;
`

const NavItem = styled.button`
  align-items: center;
  background: transparent;
  border: none;
  border-radius: 5px;
  color: ${colors.gray1};
  cursor: pointer;
  display: flex;
  gap: 8px;
  outline: none;
  padding: 12px 16px;
  text-align: left;
  width: 100%;

  &[aria-current='page'] {
    background-color: ${colors.blue3} !important;
    color: ${colors.white} !important;
  }

  &:hover,
  &:focus,
  &:focus-visible,
  &:active {
    background-color: ${colors.gray1} !important;
    color: ${colors.white} !important;
  }

  &[aria-current='page'] .anticon,
  &:hover .anticon,
  &:focus .anticon,
  &:active .anticon {
    color: ${colors.white} !important;
  }
`

const ComponentMenu = props => {
  const [activeKey, setActiveKey] = useState(props.history.location.pathname)

  return (
    <Container bordered bodyStyle={{ padding: 8 }}>
      <Nav aria-label="My account sections">
        {menuOptions.map(({ icon, title, route }) => (
          <NavItem
            key={route}
            type="button"
            aria-current={activeKey === route ? 'page' : undefined}
            onClick={() => {
              setActiveKey(route)
              props.history.push(route)
            }}
          >
            <Icon type={icon} aria-hidden />
            {title}
          </NavItem>
        ))}
      </Nav>
    </Container>
  )
}

ComponentMenu.propTypes = {}

export default withRouter(ComponentMenu)
